const getBaseComponent = require('../Components/baseComponent');

const defaultTracker = {
    track: (...args) => {
        console.log('BaseEvent was not provided a tracker, unable to track: ', args);
    }
};

module.exports = (flex = window.flex) => {

    const baseComponent = getBaseComponent(flex);

    class BaseTrackingEvent {
        constructor({ actionName = '', trackers = [defaultTracker] }) {
            this.trackers = trackers;
            this.actionName = actionName;

            let tabId = sessionStorage.getItem('tabId');
            if (!tabId) {
                tabId = flex.uuid();
                sessionStorage.setItem('tabId', tabId);
            }
            this.tabId = tabId;
        }

        track(values) {
            let baseValues = this.getPossibleBaseValues(),
                trackedComponentComposition = Object.assign(baseComponent.trackedValues(baseValues), values);

            this.trackers.forEach(tracker => { tracker.track(this.actionName, trackedComponentComposition) });
        }

        getPossibleBaseValues() {
            let { appContext = {} } = flex.getStore(),
                { session, app, userContext } = appContext;

            return Object.assign(
                {},
                { session, app, userContext, tabId: this.tabId }
            );
        }
    }

    return BaseTrackingEvent;
};